import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import { Table } from 'reactstrap';
import { object, bool } from 'prop-types';
import DateTime from '../../DateTime/DateTime';
import { createMarkup } from '../../../utils/utils';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { STATIC_PATH } from '../../../config';

class NewsListItem extends PureComponent {
  static propTypes = {
    news: object.isRequired,
    groupByDate: bool,
    inOffer: bool,
  };

  static defaultProps = {
    news: {},
    changeDate: false,
  };

  getPossibleOfferLink = (news) => {
    const regExpOffer = /<a[^>]+href=['"]?[^'" ]*?\/offers\/(\d+)[^'" ]*?[^>]*>(.*?)<\/a>/gi;
    const preparedNews = { ...news };
    const match = regExpOffer.exec(preparedNews.text);
    let text;
    let offerId;
    let offerTitle;
    if (match && match[0] && match[1] && match[2]) {
      text = preparedNews.text.replace(match[0], '');
      offerId = match[1];
      offerTitle = match[2];
    }
    return {
      news: {
        ...preparedNews,
        text: match ? text : preparedNews.text,
      },
      offerId,
      offerTitle,
    };
  };

  render() {
    const { groupByDate, inOffer, news } = this.props;

    return (
      <div className="news-item">
        {/* {groupByDate && news.changeDate && (
          <Moment element="h3" format="DD MMMM" unix>
            {news.its}
          </Moment>
        )} */}

        {groupByDate ? (
          <div className="news-item-wrapper">
            <div className="news-info-wrapper">
              <div className="news-title">
                <DateTime className="news-date" timestamp={news.its} />
                <Link to={`/news/${news.id}`}>{news.title}</Link>
              </div>
              <div className="news-text">
                <p dangerouslySetInnerHTML={createMarkup(news.text)} />
              </div>
            </div>
          </div>
        ) : (
          <>
            {inOffer ? (
              <div className="news-info-wrapper">
                <div className="news-title">
                  <DateTime className="news-date" timestamp={news.its} />
                  <Link to={`/news/${news.id}`}>{news.title}</Link>
                </div>
                <div className="news-text">
                  <span dangerouslySetInnerHTML={createMarkup(news.text)} />
                </div>
              </div>
            ) : (
              [
                <div key="td-1">
                  <DateTime className="news-date" timestamp={news.its} />
                </div>,
                <div key="td-2">
                  <div className="news-title">
                    <Link to={`/news/${news.id}`}>{news.title}</Link>
                  </div>
                  <div className="news-text">
                    <span dangerouslySetInnerHTML={createMarkup(news.text)} />
                  </div>
                </div>,
              ]
            )}
          </>
        )}
      </div>
    );
  }
}

export default NewsListItem;
